import { QuestionCircleOutlined } from "@ant-design/icons";
import { Tooltip, TooltipProps } from "antd";
import * as React from "react";

interface Props {
  tooltipProps: TooltipProps;
}
export const CpTooltip: React.FC<Props> = ({ tooltipProps }) => {
  const { mouseEnterDelay, ...props } = tooltipProps;

  return (
    <Tooltip mouseEnterDelay={0.3} overlayStyle={{ width: "max-content", maxWidth: 600 }} {...props}>
      <QuestionCircleOutlined style={{ fontSize: 16 }} />
    </Tooltip>
  );
};
